var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarWashLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_268",
    "data-name": "Group 268",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.785,
    height: 118.586,
    viewBox: "0 0 151.785 118.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 151.785,
    height: 118.586,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268-2",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M10.791,231.2a10.049,10.049,0,0,1-4.188-.886,10.816,10.816,0,0,1-3.443-2.455,11.763,11.763,0,0,1,0-16.1A10.882,10.882,0,0,1,6.6,209.312a10.048,10.048,0,0,1,4.188-.886,10.035,10.035,0,0,1,4.909,1.231,11.066,11.066,0,0,1,3.718,3.286l-4.2,2.258a6.193,6.193,0,0,0-1.96-1.506,5.647,5.647,0,0,0-4.823-.047,6.148,6.148,0,0,0-1.945,1.435,6.755,6.755,0,0,0-1.31,2.125,7.4,7.4,0,0,0,0,5.192,6.738,6.738,0,0,0,1.31,2.125,6.246,6.246,0,0,0,1.945,1.443,5.572,5.572,0,0,0,4.823-.047,6.17,6.17,0,0,0,1.96-1.53l4.2,2.29a11.211,11.211,0,0,1-3.718,3.278,9.982,9.982,0,0,1-4.909,1.239",
    transform: "translate(0 -133.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M66.256,210.692h5.3l7.968,21.96H74.538L73.283,229.2H64.531l-1.254,3.451H58.288Zm0,13.8h5.3l-2.667-7.278Z",
    transform: "translate(-37.301 -134.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M124.245,232.652v-21.96h8.941a6.043,6.043,0,0,1,3.263.91,6.65,6.65,0,0,1,2.313,2.439,6.779,6.779,0,0,1,.855,3.365,7.212,7.212,0,0,1-.471,2.627,6.627,6.627,0,0,1-1.341,2.149,6.786,6.786,0,0,1-2.047,1.5l5.207,8.972h-5.427l-4.957-8.533h-1.631v8.533Zm4.705-13.239h3.671a2.12,2.12,0,0,0,1.145-.321,2.457,2.457,0,0,0,.832-.855,2.362,2.362,0,0,0,0-2.353,2.459,2.459,0,0,0-.832-.855,2.13,2.13,0,0,0-1.145-.322h-3.671Z",
    transform: "translate(-79.51 -134.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M185.658,232.652l-5.615-21.96H184.9l3.388,13.3,3.388-13.3h4.329l3.388,13.3,3.388-13.3h4.862l-5.584,21.96h-5.3l-2.918-11.388-2.887,11.388Z",
    transform: "translate(-115.218 -134.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M264.247,210.692h5.3l7.968,21.96h-4.988l-1.255-3.451h-8.753l-1.254,3.451h-4.988Zm0,13.8h5.3l-2.667-7.278Z",
    transform: "translate(-164.005 -134.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M326.224,231.2a10.73,10.73,0,0,1-3.545-.588,8.915,8.915,0,0,1-2.965-1.694,6.372,6.372,0,0,1-1.835-2.643l4.423-1.631a1.991,1.991,0,0,0,.7.878,4.5,4.5,0,0,0,1.373.7,5.871,5.871,0,0,0,1.851.275,5.605,5.605,0,0,0,1.772-.275,3.575,3.575,0,0,0,1.349-.761,1.5,1.5,0,0,0,.518-1.129,1.338,1.338,0,0,0-.541-1.09,4.173,4.173,0,0,0-1.38-.69,11.233,11.233,0,0,0-1.718-.385,17.514,17.514,0,0,1-4.274-1.137,7.221,7.221,0,0,1-2.98-2.188,5.582,5.582,0,0,1-1.09-3.544,5.826,5.826,0,0,1,1.16-3.6,7.747,7.747,0,0,1,3.067-2.408,9.868,9.868,0,0,1,4.118-.863,10.8,10.8,0,0,1,3.553.588,8.827,8.827,0,0,1,2.972,1.7,6.285,6.285,0,0,1,1.82,2.667l-4.423,1.6a1.943,1.943,0,0,0-.7-.871,4.5,4.5,0,0,0-1.372-.682,6.049,6.049,0,0,0-1.851-.266,5.107,5.107,0,0,0-1.741.266,3.822,3.822,0,0,0-1.365.768,1.459,1.459,0,0,0-.533,1.1,1.545,1.545,0,0,0,.5,1.263,3.021,3.021,0,0,0,1.326.588q.823.173,1.811.314a15.708,15.708,0,0,1,4.157,1.177,8.066,8.066,0,0,1,3.043,2.259,5.282,5.282,0,0,1,1.145,3.435,5.851,5.851,0,0,1-1.153,3.6,7.7,7.7,0,0,1-3.051,2.407,9.889,9.889,0,0,1-4.141.863",
    transform: "translate(-203.427 -133.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M386.3,210.692h4.706v21.96H386.3v-9.411h-7.78v9.411h-4.706v-21.96h4.706v7.843h7.78Z",
    transform: "translate(-239.222 -134.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M155.417,280.566h3.526l6.387,17.567h-3.25l-1.129-3.112h-7.529l-1.129,3.112h-3.25Zm-.879,11.394h5.283l-2.648-7.241Z",
    transform: "translate(-95.379 -179.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M201.564,298.133V280.565h6.274a4.845,4.845,0,0,1,2.591.715,5.222,5.222,0,0,1,1.838,1.921,5.3,5.3,0,0,1,.678,2.647,5.234,5.234,0,0,1-.7,2.679,5.325,5.325,0,0,1-1.864,1.907,4.819,4.819,0,0,1-2.547.709h-3.212v6.99Zm3.062-10.051h2.886a2.261,2.261,0,0,0,1.192-.326,2.433,2.433,0,0,0,.859-.879,2.4,2.4,0,0,0,.32-1.23,2.432,2.432,0,0,0-1.18-2.12,2.26,2.26,0,0,0-1.192-.326h-2.886Z",
    transform: "translate(-128.991 -179.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M240.911,298.133V280.565h6.274a4.845,4.845,0,0,1,2.591.715,5.223,5.223,0,0,1,1.838,1.921,5.3,5.3,0,0,1,.678,2.647,5.234,5.234,0,0,1-.7,2.679,5.325,5.325,0,0,1-1.864,1.907,4.819,4.819,0,0,1-2.547.709h-3.212v6.99Zm3.062-10.051h2.886a2.26,2.26,0,0,0,1.192-.326,2.432,2.432,0,0,0,.859-.879,2.4,2.4,0,0,0,.32-1.23,2.431,2.431,0,0,0-1.18-2.12,2.26,2.26,0,0,0-1.192-.326h-2.886Z",
    transform: "translate(-154.171 -179.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M121.509,33.482a5.063,5.063,0,0,1-1.9-3.954,4.416,4.416,0,0,1,4.411-4.411h3.513a4.17,4.17,0,0,1,2.835,1.113l1.651-2.477a11.955,11.955,0,0,1,10-5.31H161.26a11.957,11.957,0,0,1,10,5.313l1.648,2.473a4.169,4.169,0,0,1,2.834-1.112h3.513a4.416,4.416,0,0,1,4.411,4.411,5.064,5.064,0,0,1-1.9,3.953,11.749,11.749,0,0,1,2.853,4.257,33.277,33.277,0,1,0-65.958,0,11.747,11.747,0,0,1,2.852-4.256",
    transform: "translate(-75.744 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M197.9,167.889c-.063-.044-.128-.085-.189-.131l-2.262-1.694a1.25,1.25,0,0,0-.754-.254H167.979a1.237,1.237,0,0,0-.741.247l-2.289,1.711c-.056.042-.116.08-.174.12v.367a33.321,33.321,0,0,0,33.127,0Z",
    transform: "translate(-105.448 -106.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M146.487,77.2a12.966,12.966,0,0,0,4.2.7h22.183a12.965,12.965,0,0,0,4.2-.7l12.274-4.192a10.152,10.152,0,0,0-5.232-2.081L179,63.253a9.112,9.112,0,0,0-7.6-4.027H152.158a9.112,9.112,0,0,0-7.6,4.027l-5.113,7.673a10.154,10.154,0,0,0-5.232,2.08Z",
    transform: "translate(-85.889 -37.902)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M183.939,99.811l-12.83,4.383a14.055,14.055,0,0,1-4.552.756H144.373a14.057,14.057,0,0,1-4.552-.756l-12.83-4.383a10.577,10.577,0,0,0-2.649,7.622v14.213a1.974,1.974,0,0,0,1.975,1.975h9.85a1.957,1.957,0,0,0,1.183-.4l2.278-1.7a4.11,4.11,0,0,1,2.476-.828h26.718a4.123,4.123,0,0,1,2.481.828l2.274,1.7a1.966,1.966,0,0,0,1.183.4h9.854a1.977,1.977,0,0,0,1.975-1.975V107.433a10.577,10.577,0,0,0-2.649-7.622",
    transform: "translate(-79.572 -63.874)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M129.3,172.219a1.16,1.16,0,0,0,1.16,1.16h7.571a1.16,1.16,0,0,0,1.16-1.16v-2.056H129.3Z",
    transform: "translate(-82.747 -108.895)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M264.782,172.219a1.16,1.16,0,0,0,1.16,1.16h7.571a1.16,1.16,0,0,0,1.16-1.16v-2.056h-9.892Z",
    transform: "translate(-169.447 -108.895)",
    fill: "#27b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M186.219,27.142l.812,2.195,2.195.812a.089.089,0,0,1,0,.167l-2.195.812-.812,2.195a.089.089,0,0,1-.167,0l-.812-2.195-2.195-.812a.089.089,0,0,1,0-.167l2.195-.812.812-2.195a.089.089,0,0,1,.167,0",
    transform: "translate(-117.103 -17.332)",
    fill: "#0182f0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M158.332,72.178l3.481-5.223a7.351,7.351,0,0,1,6.153-3.255h18.5a7.35,7.35,0,0,1,6.151,3.253l3.482,5.224Z",
    transform: "translate(-101.324 -40.765)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M139.883,119.022l-6.963-.33a1.335,1.335,0,0,1-1.272-1.333v-1.87a1.893,1.893,0,0,1,2.234-1.863l8.586,1.569a.836.836,0,0,1,.524,1.317l-1.159,1.58a2.284,2.284,0,0,1-1.949.93",
    transform: "translate(-84.248 -72.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M142.133,154.931h-4.774a.781.781,0,0,1-.7-1.125l.736-1.5a.781.781,0,0,1,.7-.438h4.742a.781.781,0,0,1,.708,1.113l-.7,1.5a.781.781,0,0,1-.708.45",
    transform: "translate(-87.402 -97.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M166.3,128.684a.825.825,0,0,1-.848-1l.589-2.211a5.92,5.92,0,0,1,5.368-4.326c.138-.008.276-.012.418-.012h19.816c.138,0,.28,0,.418.012a5.929,5.929,0,0,1,5.369,4.326l.585,2.211a.824.824,0,0,1-.844,1Z",
    transform: "translate(-105.865 -77.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M261.107,119.022l6.963-.33a1.335,1.335,0,0,0,1.272-1.333v-1.87a1.893,1.893,0,0,0-2.234-1.863l-8.586,1.569a.836.836,0,0,0-.524,1.317l1.159,1.58a2.284,2.284,0,0,0,1.949.93",
    transform: "translate(-165.001 -72.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M266.79,154.931h4.774a.781.781,0,0,0,.7-1.125l-.736-1.5a.781.781,0,0,0-.7-.438h-4.742a.782.782,0,0,0-.708,1.113l.7,1.5a.781.781,0,0,0,.708.45",
    transform: "translate(-169.781 -97.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M167.978,88.879l.668,1.806,1.806.668a.073.073,0,0,1,0,.137l-1.806.669-.668,1.806a.073.073,0,0,1-.137,0l-.668-1.806-1.806-.669a.073.073,0,0,1,0-.137l1.806-.668.668-1.806a.073.073,0,0,1,.137,0",
    transform: "translate(-105.795 -56.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M135.909,81.485h-3.893a2.193,2.193,0,0,1-2.193-2.192,1.53,1.53,0,0,1,1.531-1.531h3.514a1.31,1.31,0,0,1,1.31,1.31v2.145a.268.268,0,0,1-.268.268",
    transform: "translate(-83.08 -49.764)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M274.355,81.485h3.893a2.193,2.193,0,0,0,2.193-2.192,1.53,1.53,0,0,0-1.531-1.531H275.4a1.31,1.31,0,0,0-1.31,1.31v2.145a.268.268,0,0,0,.268.268",
    transform: "translate(-175.402 -49.764)",
    fill: "#f79420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M221.8,13.143l1.29,3.486,3.486,1.29a.141.141,0,0,1,0,.265l-3.486,1.29L221.8,22.96a.141.141,0,0,1-.265,0l-1.29-3.486-3.486-1.29a.141.141,0,0,1,0-.265l3.486-1.29,1.29-3.486a.141.141,0,0,1,.265,0",
    transform: "translate(-138.653 -8.352)",
    fill: "#0182f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M264.048,35.7l.9,2.439,2.439.9a.1.1,0,0,1,0,.185l-2.439.9-.9,2.439a.1.1,0,0,1-.185,0l-.9-2.439-2.439-.9a.1.1,0,0,1,0-.185l2.439-.9.9-2.439a.1.1,0,0,1,.185,0",
    transform: "translate(-166.679 -22.804)",
    fill: "#0182f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWashLogo);
export default __webpack_public_path__ + "static/media/CarWash-Logo.0c1bf022540ad8a58f2359d0b0b6b364.svg";
export { ForwardRef as ReactComponent };